import { gql } from "@apollo/client";

export const UPLOAD_OFFENSE_CSV = gql`
  mutation NFLMatchupAdvantageTableMutation($csv: Upload!) {
    uploadOffensiveMatchupRankings(csvFile: $csv) {
      success
    }
  }
`;

export const UPLOAD_DEFENSE_CSV = gql`
  mutation NFLMatchupAdvantageTableDefenseMutation($csv: Upload!) {
    uploadDefensiveMatchupRankings(csvFile: $csv) {
      success
    }
  }
`;
